import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import { Button, Loader } from '@kanda-libs/ks-design-library';
import Fields from './Fields';
import useEnquiryWorkDetailsForm from './useEnquiryWorkDetailsForm';

const EnquiryWorkDetails: React.FunctionComponent = function () {
  const { form, onSubmit, isLoading, isSubmitting } =
    useEnquiryWorkDetailsForm();
  return (
    <Form id="enquiry-work-details" form={form} onSubmit={onSubmit}>
      <FormTheme variant="streamline">
        <div className="flex flex-col gap-y-6">
          <Fields />
          <Button.Text
            id="enquiry-work-details-submit"
            submit
            label="Next"
            variant="gradient"
            disabled={isLoading || isSubmitting}
          />
          <Loader isLoading={isSubmitting} />
        </div>
      </FormTheme>
    </Form>
  );
};

export default EnquiryWorkDetails;
